<template>
  <section>
    
    <nav-component titulo="Métodos de pago" :link="can('metodos.registrar') ? { path: '/agregar-metodo' } : null" texto="Agregar método de pago" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item acive>Métodos de pago</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="mt-2" v-if="metodos.length > 0">
      <b-select v-model="perPage" @input="onPerPageChange">
        <option :value="5">5 por página</option>
        <option :value="10">10 por página</option>
        <option :value="15">15 por página</option>
        <option :value="20">20 por página</option>
        <option :value="null">Todos</option>
      </b-select>

      <b-table class="box" :data="metodos" :paginated="isPaginated" :per-page="perPage || total || 1" :current-page="currentPage"
        :backend-pagination="true" :total="total" @page-change="onPageChange"
        :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize" aria-next-label="Next page" aria-previous-label="Previous page"
        aria-page-label="Page" aria-current-label="Current page">
        <b-table-column field="nombre" label="Nombre" sortable searchable v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>

        <b-table-column field="tipo" label="Plataforma" sortable searchable v-slot="props">
          {{ props.row.tipo }}
        </b-table-column>

        <b-table-column field="acciones" label="Acciones" v-slot="props" v-if="can('metodos.eliminar')">
          <b-button type="is-danger" @click="eliminar(props.row.id)">
            <b-icon icon="delete">
            </b-icon>
          </b-button>
          <b-button tag="router-link" class="ml-4" type="is-warning" :to="{ name: 'EditarMetodo', params: { id: props.row.id } }" v-if="can('metodos.editar')">
            <b-icon icon="pen">
            </b-icon>
          </b-button>
        </b-table-column> 
      </b-table>
    </div>
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import NavComponent from '../Extras/NavComponent.vue';

export default {
  name: "MetodosComponent",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    metodos: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: 'bottom',
    defaultSortDirection: 'asc',
    sortIcon: 'arrow-up',
    sortIconSize: 'is-medium',
    currentPage: 1,
    perPage: 5,
    total: 0,
  }),

  mounted() {
    this.obtenerDatos()
  },

  methods: {
    obtenerDatos() {
      this.cargando = true
      HttpService.obtenerConConsultas('metodos.php', {
        accion: 'obtener',
        pagina: this.perPage === null ? null : this.currentPage,
        limite: this.perPage,
      }).then(resultado => {
        this.metodos = resultado.metodos
        this.total = resultado.total
        this.cargando = false
      })
    },

    onPageChange(page) {
      this.currentPage = page
      this.obtenerDatos()
    },

    onPerPageChange() {
      this.currentPage = 1
      this.obtenerDatos()
    },

    eliminar(id) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar método de pago',
        message: '¿Seguro que deseas eliminar este método de pago? Se ocultará para nuevas operaciones pero se conservará en las facturas existentes.',
        confirmText: 'Sí, eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.cargando = true
          HttpService.eliminar('metodos.php', {
            accion: 'eliminar',
            id: id
          }).then(resultado => {
            this.cargando = false
            if (resultado) {
              this.$buefy.toast.open({
                type: 'is-success',
                message: 'Método de pago eliminado (soft delete)'
              })
              this.obtenerDatos()
            } else {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'No se pudo eliminar el método de pago'
              })
            }
          })
        }
      })
    },

    // editar(id) {
    //   this.$router.push({
    //     name: "EditarMetodo",
    //     params: { id }
    //   })
    // },
  }
}
</script>
